import React, {useMemo} from 'react';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {isEqual} from 'lodash';

const SortingColumnHeader = ({text, fieldName, useContext, showDefaultIcon = false}) => {
  const context = useContext();

  const {queryParams, setQueryParams} = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
  }), [context]);

  const sortByField = queryParams?.sortByField || '';
  const sortByOrder = parseInt(queryParams?.sortByOrder, 10) || 0;

  const isActive = sortByField === fieldName;

  const handleSort = () => {
    let newOrder;

    if (!isActive) {
      newOrder = 1;
    } else {
      newOrder = sortByOrder === 1 ? -1 : 1;
    }

    const newQueryParams = {
      ...queryParams,
      sortByField: fieldName,
      sortByOrder: newOrder,
    };

    if (!isEqual(newQueryParams, queryParams)) {
      setQueryParams(newQueryParams);
    }
  };

  const getIcon = () => {
    if (!isActive) {
      return showDefaultIcon && !sortByField && !sortByOrder
        ? '/media/common/Triangle_down_white.svg'
        : null;
    }

    return sortByOrder === 1
      ? '/media/common/Triangle_up_white.svg'
      : '/media/common/Triangle_down_white.svg';
  };

  const icon = getIcon();

  return (
    <div className="d-flex align-items-center position-relative">
      <div className="cursor-pointer" onClick={handleSort}>
        {text}
      </div>
      <div className="ml-2 w-30px">
        {icon && (
          <div className="d-flex position-absolute right-5 top-0">
            <img
              src={toAbsoluteUrl(icon)}
              alt="sort"
              height={24}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SortingColumnHeader;